import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
  },
];

export const CareHealthCenterToEyeDisease = {
  label: "照護衛生所 VS 眼疾",
  key: "CareHealthCenterToEyeDisease",
  path: "FundusAbnormal/CareHealthCenterToEyeDisease",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.FundusAbnormal.CareHealthCenterToEyeDisease {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "HRegion",
      field: "HRegion",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
